/*
    Note: adding a settings called "typeahead-popup-class" so that we can style the drop down if desired.
*/
(function () {
    'use strict';

    angular
        .module('app.core')
        .decorator('uibTypeaheadDirective', uibTypeaheadDecorator);

    var $ = angular.element,
        ARIA_OWNS = 'aria-owns',
        DEFAULT_TEMPLATE_URL = 'uib/template/typeahead/typeahead-popup.html';

    uibTypeaheadDecorator.$inject = ['$delegate', '$document', '$templateRequest'];
    function uibTypeaheadDecorator($delegate, $document, $templateRequest) {
        var originalCompile = $delegate[0].compile;
        $delegate[0].compile = compile;
        return $delegate;

        function compile() {
            var originalLink = originalCompile.apply(this, arguments);

            return function link(scope, element, attrs, ctrls) {
                var popupClass = attrs.typeaheadPopupClass,
                    popupTemplateUrl = attrs.typeaheadPopupTemplateUrl || DEFAULT_TEMPLATE_URL,
                    popupId, popup;

                originalLink.apply(this, arguments);

                if (popupClass) {
                    // The popup directive has replace set to true, so if we find the element now, it will be the one that gets replaced.
                    // As soon as this returns, we know we are safe.
                    $templateRequest(popupTemplateUrl).then(addClass);
                }

                function addClass() {
                    popupId = element.attr(ARIA_OWNS);
                    popup = $($document[0].getElementById(popupId));
                    popup.addClass(popupClass);
                }
            }
        }
    }
})();